class PaydayTimer extends HTMLElement {
  connectedCallback() {
    this.endDate = this.getAttribute('data-end-date');
    if (!this.endDate) {
      this.handleExpired();
      return;
    }

    this.endTime = new Date(this.endDate).getTime();
    if (isNaN(this.endTime)) {
      this.handleExpired();
      return;
    }

    this.hoursEl = this.querySelector('[data-hours]');
    this.minsEl = this.querySelector('[data-minutes]');
    this.secsEl = this.querySelector('[data-seconds]');

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  update() {
    const now = Date.now();
    const diff = this.endTime - now;

    if (diff <= 0) {
      this.handleExpired();
      return;
    }

    const totalHours = Math.floor(diff / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const secs = Math.floor((diff % 60000) / 1000);

    if (this.hoursEl) this.hoursEl.textContent = String(totalHours).padStart(2, '0');
    if (this.minsEl) this.minsEl.textContent = String(mins).padStart(2, '0');
    if (this.secsEl) this.secsEl.textContent = String(secs).padStart(2, '0');
  }

  handleExpired() {
    if (this.interval) clearInterval(this.interval);

    const timerWrap = this.closest('.payday-timer-wrap');
    if (timerWrap) timerWrap.style.display = 'none';

    const soldOut = this.closest('.card-information__wrapper')
      ? this.closest('.card-information__wrapper').querySelector('.payday-sold-out')
      : null;
    if (soldOut) soldOut.style.display = 'block';

    const productItem = this.closest('.product-item');
    if (productItem) productItem.classList.add('is-sold-out');

    const addToCartBtns = productItem
      ? productItem.querySelectorAll('.card-action button, .card-action .btn, [data-add-to-cart]')
      : [];
    addToCartBtns.forEach(btn => {
      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';
    });
  }
}

if (!customElements.get('payday-timer')) {
  customElements.define('payday-timer', PaydayTimer);
}
